import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

import { Pagination } from './pagination.types'
import { Error } from './error.types'

interface ComplaintData {
  id: number
  ciap_code: string
  description: string
}

interface ListComplaintsData {
  complaints: ComplaintData[]
  pagination: Pagination
}

interface Complaint {
  id: number
  ciapCode: string
  description: string
}

interface ListComplaintsResponse {
  complaints: Complaint[]
  pagination: Pagination
}

export const listComplaints = (query?: string, page?: number): Promise<ListComplaintsResponse> => {
  const endpoint = apiEndpoints.MEDICAL_RECORDS_COMPLAINTS

  const params = {
    per_page: 10,
    ...(query && { query }),
    ...(page && { page }),
  }

  return new Promise<ListComplaintsResponse> ((resolve, reject) => {
    axios.get<ListComplaintsData>(endpoint, { params })
      .then(response => {
        const complaints = response.data.complaints.map(complaint => {
          return {
            ciapCode: complaint.ciap_code,
            description: complaint.description,
            id: complaint.id,
          } as Complaint
        })

        const pagination = response.data.pagination

        resolve({
          complaints,
          pagination,
        })
      })
      .catch((error: Error) => 
        reject(error?.response?.status)
      )
  })
}